export const counterpartyKeys = {
  all: ['counterparties'] as const,
  lists: () => [...counterpartyKeys.all, 'list'] as const,
  list: (params: object) => [...counterpartyKeys.lists(), params] as const,
  filterOptions: () => [...counterpartyKeys.all, 'filter-options'] as const,
  formTypes: () => [...counterpartyKeys.all, 'form-types'] as const,
};
